import { Component, OnInit, OnDestroy, AfterViewInit, OnChanges, Input } from '@angular/core';
import { PlantServiceService, CommonService } from 'src/app/services/index';
import { Chart } from 'angular-highcharts';
import * as moment from 'moment';
import {Highcharts$} from '../../../../../shared/index';
import { TreeNode } from 'src/app/orgChart/common/treenode';
import { MatExpansionPanel } from '@angular/material';
import * as ObjectUtils from 'util';
import { Subject } from 'rxjs';
@Component({
  selector: 'app-solar-yield',
  templateUrl: './solar-yield.component.html',
  styleUrls: ['./solar-yield.component.scss']
})
export class SolarYieldComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  siteId: string;
  yieldTypes = [
    {value: 'Yearly', viewValue: 'Yearly'},
    {value: 'Monthly', viewValue: 'Monthly'},
    {value: 'Hourly', viewValue: 'Today(Hourly)'}
  ];
  yieldTypeSelected = 'Hourly';
  solarYieldChart: Chart;
  solarYieldChartBuildingWise: Chart;
  querySiteId: object;
  enableShiftwise = false;
  inverterTreeData: any;
  loadONTreeData: TreeNode[];
  selectedNode: TreeNode;
  nodeLevel = 1;
  inverterTreeNodesConnStatus = [];
  inverterTreeNodesPowerInfo = [];
  inverterTreeNodesDCPowerInfo = [];
  meterIdsForLoadONTree = [];
  metersForLoadONTree = [];
  buildingsLoadsMeters = [];
  isLoading = false;
  isFirstLoad = true;
  icon = true;
  isExpanded = true;
  isNotViewFull = true;
  buttons: any;
  @Input() resizeSubscription: Subject<any>;
  constructor(private plantService: PlantServiceService, private commonService: CommonService) {
      this.loadONTreeData = [];
      const chartOption = this.onInitChart(moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD'), []);
      this.solarYieldChart = new Chart(<any>chartOption);
    }

  ngOnInit() {
    const self = this;
    this.plantService.getSolarConfigSubject().subscribe((solarConfig) => {
      this.siteId = solarConfig.siteId;
      this.querySiteId = Object.assign({ }, {'siteId': this.siteId});
      self.onProcessChart();
    });
  }
  ngOnChanges() {
  }
  ngAfterViewInit() {
    // this.cd.detectChanges();
    this.isFirstLoad = false;
    const seft = this;
    this.resizeSubscription.subscribe(event => {
      this.onResize(event);
    });
    this.buttons = Highcharts$.getOptions().exporting.buttons;
    Highcharts$.setOptions({
      exporting: {
        buttons: {
          contextButton: {
            menuItems: this.buttons.contextButton.menuItems.slice(0, 2)
          }
        }
      }
    });
    document.addEventListener('fullscreenchange', function () {
      if (seft.solarYieldChart.ref) {
        seft.solarYieldChart.ref.update({
          exporting: {
            buttons: {
              contextButton: {
                menuItems: seft.isNotViewFull ? seft.buttons.contextButton.menuItems.slice(1, 2) :
                  seft.buttons.contextButton.menuItems.slice(0, 2)
              }
            }
          }
        });
      }
      seft.isNotViewFull = !seft.isNotViewFull;
    });
  }
  ngOnDestroy() {
    document.removeEventListener('fullscreenchange', function () { });
  }
  onResize(event) {
    const seft = this;

    const dom = document.getElementById('chartContainer');
      if (seft.commonService.isNullOrUndefined(dom) ) {
        return;
      }
      if (dom && dom.clientHeight > 400) {
        setTimeout(() => {
          dom.setAttribute('height', '400');
        }, 200);
      }
      if (document.fullscreenElement) {
        seft.solarYieldChart.ref.setSize(document.documentElement.clientWidth, document.documentElement.clientHeight );
      } else {
        seft.solarYieldChart.ref.setSize(dom.clientWidth, dom.clientHeight < 400 ? dom.clientHeight : 400);

      }

  }
  onYieldTypeChange() {
    this.onProcessChart();
  }
  checkShiftwise(event: any) {
    this.enableShiftwise = event.checked;
    // this.solarYieldChart = new Highcharts$.Chart();
    // this.solarYieldChart.showLoading();
    this.onProcessChart();
  }
  onProcessChart() {
    // if (this.solarYieldChart !== null) {
    //   this.solarYieldChart.destroy();
    // }
    // if (this.solarYieldChartBuildingWise !== null) {
    //   this.solarYieldChartBuildingWise.destroy();
    // }
    if (this.yieldTypeSelected !== '') {
      if (this.yieldTypeSelected === 'Monthly') {
        const endDate = moment().subtract(1, 'd').format('YYYY-MM-DD');
        const startDate = moment(endDate).startOf('month').format('YYYY-MM-DD');
        this.getSolarYield(startDate, endDate, false);
      } else if (this.yieldTypeSelected === 'Hourly') {
        const startDate = moment().format('YYYY-MM-DD');
        this.getSolarYield(startDate, startDate, true);
      }else if (this.yieldTypeSelected === 'Yearly') {
        const endDate = moment().subtract(1, 'd').format('YYYY-MM-DD');
        const startDate = moment(endDate).startOf('year').format('YYYY-MM-DD');
        this.getSolarYield(startDate, endDate, false);
      }
      }
  }

  getSolarYield(startDate: string, endDate: string, hourWiseDataRequired: boolean) {
    // Test
    // startDate = '2018-06-01';
    // endDate = '2018-06-02';
    // hourWiseDataRequired = false;
    let chartSeries = [];
    //  if (this.isFirstLoad === false) {
    //   this.isLoading = true;
    // }
    this.isLoading = true;
    if (this.enableShiftwise === false) {
      const chartOption = this.onInitChart(startDate, endDate, chartSeries);
      this.solarYieldChart = new Chart(<any>chartOption);
      // Highcharts$.chart('solarYieldChart', <any>chartOption);
      this.solarYieldChart = new Chart(<any>chartOption);
      this.plantService.getSolarEnergyYieldBySiteId(this.siteId, startDate, endDate, hourWiseDataRequired).subscribe(data => {
        // this.solarYieldChart.destroy();
        console.log('Solar Data ' + JSON.stringify(data));
        if (data !== undefined && data !== null && data.length > 0) {
          chartSeries = [{ name: 'Energy', data: data }];
          // this.onInitChart(startDate, endDate, chartSeries);
          chartOption.series = chartSeries;
          // Highcharts$.chart('solarYieldChart', <any>chartOption);
          this.solarYieldChart = new Chart(<any>chartOption);
          this.isLoading = false;
        }
      });
    } else {
      const chartOption = this.onInitBuildingWiseChart(startDate, endDate, chartSeries);
      this.solarYieldChart = new Chart(<any>chartOption);
      // Highcharts$.chart('solarYieldChart', <any>chartOption);
      this.solarYieldChart = new Chart(<any>chartOption);
      // tslint:disable-next-line:max-line-length
      this.plantService.getSolarEnergyYieldTrendBuildingWise(this.siteId, startDate, endDate, hourWiseDataRequired, 'Solar').subscribe(metersPowerData => {
        // console.log('BuildingWise Solar Data ' +  JSON.stringify(metersPowerData));
        // const categories = Object.keys(metersPowerData);
        if (metersPowerData !== undefined && metersPowerData !== null) {
          const entries = Object.entries(metersPowerData);
          chartSeries = Array.from(entries).map(([key, value]) => ({ name: key, data: value }));
          chartOption.series = chartSeries;
          // Highcharts$.chart('solarYieldChart', <any>chartOption);
          this.solarYieldChart = new Chart(<any>chartOption);
          this.isLoading = false;
          // this.onInitBuildingWiseChart(startDate, endDate, chartSeries);
        }
      });
    }
  }

  onInitChart(startDate: string, endDate: string, data: any) {
    // let solarYieldData = data;
    // let graphData = data;
    let subTitleText = '';
    let xAxis = {};

    if (this.yieldTypeSelected === 'Hourly') {
      subTitleText = startDate;
      xAxis = {
        type : 'datetime',
        labels : {
          formatter : function() {
            return Highcharts$.dateFormat('%H HRS',
                this.value);
          }
        },
        crosshair : true
      };
    } else {
      subTitleText = `(${startDate} To ${endDate})`;
      xAxis = {
        type : 'datetime',
        labels : {
          formatter : function() {
            return Highcharts$.dateFormat('%a %d %b',
            this.value);
          }
        },
        crosshair : true
      };
    }
    const yieldChartOptions = {
      chart : {
        type : 'column',
        height: 150,
       // height: (9 / 16 * 100) + '%' // 16:9 ratio
      // inverted: true
      },
      title : {
        // tslint:disable-next-line:max-line-length
        text : this.yieldTypeSelected + ' Energy Yield Trend',
        style : {
          fontSize : '14px'
        }
      },
      subtitle : {
        text : subTitleText
      },
      xAxis : xAxis,
      yAxis : {
        min : 0,
        title : {
          text : 'Total Energy Generation (kWh->)'
        },
        labels : {
          format : '{value} kWh',
        },
      },
      tooltip : {
        headerFormat : '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat : '<tr><td style="color:{series.color};padding:0">{series.name}: </td>'
            + '<td style="padding:0"><b>{point.y:.3f} kWh</b></td></tr>',
        footerFormat : '</table>',
        shared : true,
        useHTML : true
      },
      plotOptions : {
        column : {
          stacking: '',
        }
      },
      legend : {
        enabled : false,
        layout : 'vertical',
        align : 'left',
         x : 40,
        verticalAlign : 'top',
         y : 10,
        title: {
          // text: ':: Drag me'
          text: ''
        },
        floating : true,
        draggable: true,
        backgroundColor : '#FFFFFF',
      },
      credits : {
        enabled : false
      },
      // series : data,
      series : [],
      exporting: {
        enabled: true,
      }
    };
    // get copy of buttons
//    const buttons = Highcharts$.getOptions().exporting.buttons.contextButton.menuItems;
// const item = {
//   text: 'Export to PNG (small)'
// };
//    buttons.push(item);
    return yieldChartOptions;
    // Highcharts$.chart('solarYieldChart', <any>yieldChartOptions);
    // this.solarYieldChart = new Chart(<any>yieldChartOptions);
  }
  onInitBuildingWiseChart(startDate: string, endDate: string, series: any) {
    // let xAxis: any;
    let subTitleText = '';
    // xAxis = {
    //   categories : categories,
    // };
    let xAxis = {};

    if (this.yieldTypeSelected === 'Hourly') {
      subTitleText = startDate;
      xAxis = {
        type : 'datetime',
        labels : {
          formatter : function() {
            return Highcharts$.dateFormat('%H HRS',
                this.value);
          }
        },
        crosshair : true
      };
    } else {
      subTitleText = `(${startDate} To ${endDate})`;
      xAxis = {
        type : 'datetime',
        labels : {
          formatter : function() {
            return Highcharts$.dateFormat('%a %d %b',
            this.value);
          }
        },
        crosshair : true
      };
    }
    const chartOption = {
      chart : {
        type: 'column',
        height : 150,
      },
      credits : {
        enabled : false
      },
      title : {
        text : this.yieldTypeSelected + ' Energy Yield Trend BuildingWise',
        style : {
          fontSize : '14px'
        }
      },
      subtitle : {
        text : subTitleText
      },
       xAxis : xAxis,
      yAxis : {
        min : 0,
        title: {
           text: 'Total Energy Generation (kWh->)'
          },
          reversedStacks : false
        },
        tooltip : {
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y:.3f} kWh</b></td></tr>',
          footerFormat: '</table>',
          shared: true,
          useHTML: true
        },
        legend : {
          enabled: true,
          layout : 'vertical',
          align : 'left',
          x : 50,
          verticalAlign : 'top',
           y : 10,
          title: {
            // text: ':: Drag me'
            text: ''
          },
          floating : true,
          draggable: true,
          backgroundColor : '#FFFFFF'
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            pointWidth: 40
          },
        },
        // series : series
        series : []
      };
        // get copy of buttons
          // var buttonsForYieldChart = Highcharts$.getOptions().exporting.buttons.contextButton.menuItems.slice();

          // buttonsForYieldChart.push({
          //     text: 'Export to Excel',
          //     onclick: function () {
          //       exportSolarYieldBuildingWise();
          //     }
          // });
          // chartOption.exporting = {
          //     buttons: {
          //         contextButton: {
          //             menuItems: buttonsForYieldChart
          //         }
          //     }
          // };
       // draw chart
      //  chartOption.series = [{data: [5204.859999999999, 2640.07, 1666.1299999999999], name: 'Solar HT'},
      //  {data: [1439.4000000000003, 567.59, 598.9899999999999], name: 'Solar park G-CLP'},
      //  {data: [5477.3999999999999995, 1055.52, 3330.21], name: 'Solar Admin'},
      //  {data: [4204.859999999999, 1640.07, 3666.1299999999999], name: 'Solar Park G-102'}];
      //  chartOption.xAxis.categories = ['08 HRS', '10 HRS', '12 HRS', '14 HRS'];
        return chartOption;
      // this.solarYieldChartBuildingWise = new Chart(<any>chartOption);
      // Highcharts$.chart('solarYieldChart', <any>chartOption);
  }
  public click = (solarYieldExpansionPanel: MatExpansionPanel, $event: any) => {
    $event.stopPropagation();
    if ($event && $event.target && $event.target.className) {
    if (ObjectUtils.isArray($event.target.className) && $event.target.className.includes('arrow-expansion-panel-customize')) {
      if ($event.target.className.includes('desc')) {
        solarYieldExpansionPanel.open();
      } else {
        solarYieldExpansionPanel.close();
      }
      this.icon = !this.icon;
    } else {
      this.icon ? solarYieldExpansionPanel.open() :  solarYieldExpansionPanel.close();
    }
  }
  }
  // public setOpened = ($event: any) => {
  //   this.isExpanded = true;
  // }
  // public setClosed = ($event: any) => {
  //   this.isExpanded = false;
  // }
}
